"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var chess_fen_1 = require("chess-fen");
var react_dnd_preview_1 = __importDefault(require("react-dnd-preview"));
exports.BoardRenderer = function (_a) {
    var board = _a.board, resizeListener = _a.resizeListener, children = _a.children, onMove = _a.onMove, boardRenderingProps = __rest(_a, ["board", "resizeListener", "children", "onMove"]);
    var renderPiece = boardRenderingProps.renderPiece, renderSquare = boardRenderingProps.renderSquare, renderBoard = boardRenderingProps.renderBoard, renderCoordinate = boardRenderingProps.renderCoordinate, renderPreviewPiece = boardRenderingProps.renderPreviewPiece, renderDroppableSquare = boardRenderingProps.renderDroppableSquare, renderDraggablePiece = boardRenderingProps.renderDraggablePiece;
    return (react_1.default.createElement(react_1.default.Fragment, null, renderBoard({
        children: (react_1.default.createElement(react_1.default.Fragment, null,
            board.coordinates.y.map(function (y, i) {
                return (react_1.default.createElement(react_1.Fragment, { key: i }, board.coordinates.x.map(function (x, j) {
                    var coordinate = x + y;
                    var position = chess_fen_1.Position.fromCoordinate(coordinate);
                    var props = { board: board, position: position };
                    return (react_1.default.createElement(react_1.Fragment, { key: coordinate }, onMove
                        ? renderDroppableSquare(__assign({ onPieceMove: onMove, renderSquare: renderSquare, lightSquare: ((j - i) % 2) === 0, Coordinate: renderCoordinate(props), Piece: renderDraggablePiece(__assign({ renderPiece: renderPiece }, props)) }, props))
                        : renderSquare(__assign({ Coordinate: renderCoordinate(props), Piece: renderPiece(props), lightSquare: ((j - i) % 2) === 0 }, props))));
                })));
            }),
            onMove ? (react_1.default.createElement(react_dnd_preview_1.default, { generator: function (props) { return renderPreviewPiece(__assign({ pieceDragObject: props.item, board: board }, props)); } })) : null)),
        style: {
            gridTemplateColumns: "repeat(" + board.columns + ", " + board.squareSize + "px)",
            gridTemplateRows: "repeat(" + board.rows + ", " + board.squareSize + "px)"
        },
        resizeListener: resizeListener
    })));
};
exports.default = exports.BoardRenderer;
